import React from "react";

import Skeleton from "@mui/material/Skeleton";

import { CertificateContainer, LogoSection, InfoSection } from "./styles";

export const ImportCertificateSkeleton: React.FC = () => {
  return (
    <CertificateContainer>
      <LogoSection>
        <Skeleton height={40} width={120} />
        <Skeleton height={26} width={200} sx={{ mt: 1 }} />
      </LogoSection>

      <InfoSection>
        <Skeleton height={20} width={100} sx={{ mb: 1 }} />
        <Skeleton height={16} width={150} />
      </InfoSection>

      <InfoSection>
        <Skeleton height={20} width={100} sx={{ mb: 1 }} />
        <Skeleton height={16} width={80} />
      </InfoSection>

      <InfoSection>
        <Skeleton height={20} width={100} sx={{ mb: 1 }} />
        <Skeleton height={16} width={100} />
      </InfoSection>

      <InfoSection>
        <Skeleton height={20} width={100} sx={{ mb: 1 }} />
        <Skeleton height={16} width={100} />
      </InfoSection>

      <InfoSection>
        <Skeleton height={20} width={100} sx={{ mb: 1 }} />
        <Skeleton height={16} width={100} />
      </InfoSection>
    </CertificateContainer>
  );
};
